import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import SessionCache from './session-cache';
import AuthenticateRoute from './authenticate-route';
import Path from './routes-path';
import HomeComponent from '../home-component/home-component';
import CommonUtils from '../../utility/common-utilities';
import LayoutShared from '../common/layout-shared/layout-shared';

let public_routes = [
    Path.LOGIN,
    Path.SIGNUP,
    Path.USERS_SIGNUP,
    Path.GULF_SIGNUP,
    Path.RMS_SIGNUP,
    Path.CSF_SIGNUP,
    Path.MPL_SIGNUP,
    Path.FLC_SIGNUP,
    Path.MSF_SIGNUP,
    Path.PUBLIC_COMPONENT,
    Path.CMO_SIGNUP,
    Path.DEMO_REQUEST,
    Path.NMD_SIGNUP,
    Path.FFL_SIGNUP,
    Path.FORGOT_PASSWORD,
    Path.PAT_NOTIFICATION,
    Path.PARENT_PAT_NOTIFICATION,
    Path.HOMEWORK_NOTIFICATION,
    Path.HOMEWORK_ASSIGN,
    Path.HOMEWORK_ASSIGN_V2,
    Path.CLAIM_FORM,
    Path.MMS_CLAIM_FORM,
    Path.MMS_JUNE_22_CLAIM_FORM,
    Path.MPL_2022_CLAIM_FORM,
    Path.MSF_2022_CLAIM_FORM,
    Path.FLC_CLAIM_FORM,
    Path.HOMEWORK_V2,
    Path.INVITATION_SUCCESS,
    `${Path.HOMEWORK_COMPLETION_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`,
    `${Path.HOMEWORK_EVALUATION_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`,
    `${Path.MOST_WRONG_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`,
    `${Path.ELO_LEVEL_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`,

    `${Path.ASSESSMENT_RESULTS_REPORT}:homeworkId/:chapter/:class/:createdDate/:schoolName/:teacherName/:city/:branch`,
    `${Path.TEST_COMPLETION_REPORT}:homeworkId/:chapter/:class/:createdDate`,
    `${Path.TEST_WRONG_ANSWER_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`,
    `${Path.TEST_ALL_QUESTIONS_REPORT}:homeworkId/:chapter/:class/:createdDate`

];

export default function RouteWrapper({
    component: Component,
    isPrivate,
    ...rest
}) {

    if (public_routes.indexOf(rest.path) != -1) {
        return <Route {...rest} component={Component} />;
    }

    let layoutShared = LayoutShared.getLayout()

    console.log(layoutShared)
    

    let status = SessionCache.isAuthenticated();

    // status = layoutShared?.state.mannualOffline ? false : status

    status = CommonUtils.isOnline() ? status : false

    console.log(status, rest, SessionCache.isVerified())

    console.trace("Who called me");

    if (!status) {
        return <Route {...rest} render={(props) => {
            return <AuthenticateRoute {...rest} component={Component}></AuthenticateRoute>
        }} />
    }

    if (SessionCache.isVerified() == 'false') {
        return <Route location={Path.LOGIN} component={HomeComponent} />
    }
    else if (status) {
        // return <Route  {...rest} component={Component} />;
        return <Route
            {...rest}
            render={(props) => (
                <Component {...props} key={rest.path} />
            )}
        />
    }

    return <Route path={Path.LOGIN} component={HomeComponent} />
}

RouteWrapper.propTypes = {

    isPrivate: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired
};

RouteWrapper.defaultProps = {

    isPrivate: false
}